export const FACEBOOK_SDK_BLOCKED = 'FACEBOOK_SDK_BLOCKED';
export const FACEBOOK_SDK_INITIALIZED = 'FACEBOOK_SDK_INITIALIZED';

export const VALIDATE_FACEBOOK_TOKEN_SUCCESS = 'VALIDATE_FACEBOOK_TOKEN_SUCCESS';
export const VALIDATE_FACEBOOK_TOKEN_ERROR = 'VALIDATE_FACEBOOK_TOKEN_ERROR';
export const RESET_FACEBOOK_TOKEN_STATE = 'RESET_FACEBOOK_TOKEN_STATE';
